export class UgskSet<T> extends Set<T> {
    public first(): T {
        const firstElement = this.values().next();
        if (firstElement) {
            return firstElement.value;
        }
    }
}
